import commaNumber from "comma-number";
import dayjs from "dayjs";

const format = commaNumber.bindWith(",", ".");
const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};
const fmtNum = (val) => format(parseFloat(val || 0).toFixed(2));

const MONTH_LABELS = Array.from({ length: 12 }, (_, i) => dayjs().month(i).format("MMM"));

const pivotMatrix = (rows) => {
  const bySupplier = new Map();
  for (const row of rows) {
    if (!bySupplier.has(row.supplier_id)) {
      bySupplier.set(row.supplier_id, {
        supplier_id: row.supplier_id,
        supplier_name: row.supplier_name,
        months: Array(12).fill(0),
        total: 0,
      });
    }
    const entry = bySupplier.get(row.supplier_id);
    const amount = parseFloat(row.amount || 0);
    if (row.month) {
      entry.months[row.month - 1] = amount;
      entry.total += amount;
    }
  }
  return Array.from(bySupplier.values()).sort((a, b) =>
    (a.supplier_name || "").localeCompare(b.supplier_name || "")
  );
};

/**
 * @param {object} params
 * @param {Array}   params.list      - flat rows from Redux state.supplierOutflow.matrix.list
 * @param {number}  params.year
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportSupplierOutflowMatrixCsv = ({
  list,
  year,
  title = "Cash Flow Actual and Projection Matrix Report",
  filename = "supplier_outflow_matrix",
}) => {
  const pivoted = pivotMatrix(list);

  const headers = ["No.", "Supplier Name", ...MONTH_LABELS, "Total"].map(escape);

  const dataRows = pivoted.map((row, i) =>
    [i + 1, row.supplier_name || "", ...row.months.map(fmtNum), fmtNum(row.total)].map(escape)
  );

  const monthTotals = Array(12).fill(0);
  pivoted.forEach((row) => row.months.forEach((v, i) => (monthTotals[i] += v)));
  const grandTotal = pivoted.reduce((sum, row) => sum + row.total, 0);

  const totalRow = ["Grand Total", "", ...monthTotals.map(fmtNum), fmtNum(grandTotal)].map(escape);

  const rows = [[year ? `${title} — ${year}` : title], [], headers, ...dataRows, [], totalRow];

  const csv = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}${year ? `_${year}` : ""}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
